import { IApplicationState } from '../../types/redux';

export const selectNonGeoJsonQuery = (state: IApplicationState) => {
  return state.nonGeoParameters.nonGeoJsonQuery;
};
